<template>
    <div class="background">
    <CustomHeader :text="$t('profile.settings')" :isShowRightIcon="true" />
    <div class="profile_container">
        <van-row class="avatar">
            <van-col span="8" offset="8" class="avatar_img">
                <img :src="dataSet?.avatarImg || defaultAvatar" alt="" @click="goToPath('/sd-avatar')">
                <div class="edit"><img src="@/assets/profile/icon_editavatar.png" alt=""
                        @click="() => goToPath('/sd-avatar')"></div>
            </van-col>
        </van-row>
        <RowField :labelText="$t('profile.brandName')" :isShowRightIcon="true"
            :rightImage="require('@/assets/profile/edit_icon.png')" bgColor="#002121" :content="dataSet?.nickName"
            @onClickRight="handleNameEdit" />
        <RowField :labelText="$t('profile.registeredAcc')" :content="dataSet?.loginAccount" bgColor="#002121" />
        <RowField :labelText="$t('profile.password')" :isShowRightIcon="true" content="* * * * * * * * *"
            bgColor="#002121" :rightImage="require('@/assets/profile/edit_icon.png')"
            @onClickRight="handlePasswordChange()" />
        <RowField :isShowRightIcon="true" :content="$t('profile.withdrawalInfo')" bgColor="#002121"
            :rightImage="require('@/assets/profile/card_icon.png')" @onClickRight="showWithdrawInfo()" />
            <RowField :isShowRightIcon="true" :content="$t('profile.withdrawalPasswordSetting')" bgColor="#002121"
            :rightImage="require('@/assets/profile/edit_icon.png')" @onClickRight="showWithdrawPassword()" />
        <div style="margin-top: 35px;"></div>
        
        <RowField :isShowRightIcon="true" :content="$t('profile.logout')" bgColor="#002121" @onClickRight="showLogout()"
            :rightImage="require('@/assets/profile/logout_icon.png')" :opacityNone="true" />
    </div>
    <NameEditPopup ref="nameEditRef" />
    <PasswordChangePopup ref="passwordChangeRef" />
    <WithdrawalInfoPopup ref="withdrawInforRef" />
    <WithdrawPasswordPopup ref="withdrawPasswordRef" />
    <LogoutPopup ref="logoutRef" />
    </div>
</template>

<script setup lang="ts">
import RowField from './components/rowField.vue';
import NameEditPopup from './components/nameEditPopup.vue';
import { ref } from 'vue';
import PasswordChangePopup from './components/passwordChangePopup.vue';
import WithdrawalInfoPopup from './components/withdrawalInfoPopup.vue';
import LogoutPopup from './components/logoutPopup.vue';
import { ProfileSettingData } from '@/view/profile/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import WithdrawPasswordPopup from './components/withdrawPasswordPopup.vue';
import defaultAvatar from '@/assets/themeFour/defaultAvatar.jpg';

const nameEditRef = ref()
const passwordChangeRef = ref()
const withdrawInforRef = ref()
const logoutRef = ref()
const withdrawPasswordRef = ref()

const props = defineProps<{
    dataSet: ProfileSettingData
}>()

const emits = defineEmits(['goToPath'])

const handleNameEdit = () => {
    nameEditRef.value.open(props.dataSet?.nickName)
}
const handlePasswordChange = () => {
    passwordChangeRef.value.open()
}
const showWithdrawInfo = () => {
    withdrawInforRef.value.open()
}
const showLogout = () => {
    logoutRef.value.open()
}
const goToPath = (path : string) => {
   emits('goToPath', path)
}
const showWithdrawPassword = () => {
    withdrawPasswordRef.value.open()
}
</script>
<style scoped>
.background {
    min-height: 100vh;
    background-color: #003534;
}

.profile_container {
    padding: 70px 25px 15px;

}

.title_text {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.45);
}

.avatar_img {
    display: flex;
    justify-content: center;
}

.avatar_img img {
    width: 65px;
    border-radius: 20px;
    border: 1px solid #00615f;
}

.avatar {
    padding: 20px;
}

.edit {
    display: flex;
    align-items: end;
    margin: 0 0px -10px -30px;
}

.edit img {
    padding: 7px;
    width: 25px;
    border: none;
}

.edit_icon {
    display: flex;
    align-items: end;
    padding: 2px;
}

.edit_icon img {
    width: 20px;
    opacity: 0.65;
}
</style>